export const baseGoalConfig = {
    name: '{name formatted as key}',
    version: 'v1',
    inputs: {},
    tasks: [],
    outputs: {},
};
